import React from 'react';

const Partnership = () => {
  return (
    <div className='flex items-center justify-center'>
      <div className='flex flex-col justify-center items-start min-h-screen px-6 md:px-12 lg:px-40 2xl:px-96'>
        <p className='text-4xl font-normal md:text-6xl md:font-medium mb-12'>
          Partnership
        </p>
        <p className='text-base text-black block whitespace-pre-wrap text-left font-light'>
          It all begins with an idea. Maybe you want to launch a business. Maybe
          you want to turn a hobby into something more. Or maybe you have a
          creative project to share with the world. Whatever it is, the way you
          tell your story online can make all the difference.
        </p>
      </div>
    </div>
  );
};

export default Partnership;
